export class HttpQueryParameter {

  constructor(public key: string, public value: string) { }

}
